// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1El9x","error":"Textarea_error__1ee82","readonly":"Textarea_readonly__qTlAG","disabled":"Textarea_disabled__20-yF"};